module.exports = __webpack_public_path__ + "static/media/main.d803a8e0.svg";